import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import sessionStorage from 'tricks/browser/agent/sessionStorage.js';
import sendBeacon from 'utils/sendBeacon';
import uuid from './uuid';
function prepareData(category, action) {
  var labelOrRef = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var ref_id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var data = {
    category: category,
    action: action
  };
  if (ref_id !== null) {
    if (labelOrRef) {
      data.label = _typeof(labelOrRef) === 'object' ? JSON.stringify(labelOrRef) : String(labelOrRef);
    }
    data.ref_id = ref_id;
  } else if (typeof labelOrRef === 'number') {
    data.ref_id = labelOrRef;
  } else if (labelOrRef) {
    data.label = _typeof(labelOrRef) === 'object' ? JSON.stringify(labelOrRef) : labelOrRef;
  }
  return data;
}
function time() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return Date.now() + ms;
}
export function getSessionToken() {
  // Get information about the current session
  var session_token = sessionStorage('session_token');
  var session_expires = sessionStorage('session_expires') || 0;

  // Check that the session is still relevant
  if (!session_token || session_expires < Date.now()) {
    var _window$DD_LOGS;
    // Create a new session token and store it.
    session_token = "".concat(Date.now(), ".").concat(uuid()).substring(0, 36);

    // Update the store
    sessionStorage('session_token', session_token);
    (_window$DD_LOGS = window.DD_LOGS) === null || _window$DD_LOGS === void 0 ? void 0 : _window$DD_LOGS.addLoggerGlobalContext('sessionToken', session_token);
  }

  // Create the expiry
  session_expires = time(30 * 60 * 1000);

  // Update the session expiry
  sessionStorage('session_expires', session_expires);

  // Return the token
  return session_token;
}
export default function track(category, action) {
  var labelOrRef = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var ref_id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  try {
    var data = Array.isArray(category) ? category.map(function (arr) {
      return prepareData.apply(void 0, _toConsumableArray(arr));
    }) : prepareData(category, action, labelOrRef, ref_id);
    if (Array.isArray(data) && data.length === 0) {
      throw new Error('Empty array data sent to track function');
    }
    sendBeacon("/api/activity/".concat(getSessionToken()), data);
  } catch (e) {
    console.log(e); // eslint-disable-line
  }
}